import { render, staticRenderFns } from "./AppDownloadDialog.pug?vue&type=template&id=1f636698&scoped=true&lang=pug&"
import script from "./AppDownloadDialog.vue?vue&type=script&lang=js&"
export * from "./AppDownloadDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadDialog.scss?vue&type=style&index=0&id=1f636698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f636698",
  null
  
)

export default component.exports